import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { renderTextField } from '../../../Forms/fieldRenderers'
import {
  required
} from '../../../Forms/fieldValidators'
import Grid from '@material-ui/core/Grid'

const maxLength = max => value =>
  value && value.length > max ? `Debe tener un máximo de ${max} caracteres de largo` : undefined
const maxLength50 = maxLength(50)

class CamposContacto extends Component {
  render () {
    const {
      handleChangeEmail,
      handleChangeNombre
    } = this.props
    return (
      <div>
        <Row>
          <Grid container justify='space-around'>
            <Col md={10}>
              <Field
                name='nombre'
                type='text'
                label='Nombre y Apellido'
                component={renderTextField}
                autoFocus
                validate={[required, maxLength50]}
                placeholder=''
                onChange={(e) => handleChangeNombre(e)}
              />
              <Field
                name='correoElectronico'
                type='text'
                label='Correo Electrónico'
                component={renderTextField}
                autoFocus={false}
                validate={[required]}
                placeholder=''
                onChange={(e) => handleChangeEmail(e)}
              />
            </Col>
          </Grid>
        </Row>
      </div>
    )
  }
}

export default CamposContacto
